<template>
  <v-container fluid>
    <div id="resume"></div>
    <div>
      <v-card class="resume-page elevation-15 animated zoomInUp">
        <h1 class="pl-3">
          <u>Blake Sutton</u>
        </h1>
        <h2 class="pl-3">Web Engineer</h2>
        <v-divider></v-divider>
        <header class="d-flex pa-3">
          <div>
            <v-icon color="black">
              mail
            </v-icon>
            <h3 class="pl-1">
              <a href="mailto:info@blakejs.com">info@blakejs.com</a>
            </h3>
          </div>
          <!-- <div>
            <v-icon color="black">
              phone
            </v-icon>
            <h3 class="pl-1">
              <a href="tel:+17063868502">(706) 386-8502</a>
            </h3>
          </div> -->
          <div>
            <v-icon color="black">
              place
            </v-icon>
            <h3 class="pl-1">
              Atlanta, GA
            </h3>
          </div>
          <div>
            <img src="/static/sprite/link.svg" alt="Linkedin" style="width: 20px;">
            <h3 class="pl-1">
              <a href="https://linkedin.com/in/blakejs">
                BlakeJS
              </a>
            </h3>
          </div>
          <div>
            <img src="/static/sprite/gh.svg" alt="Github" style="width: 20px;">
            <h3 class="pl-1">
              <a href="https://github.com/blakejs">
                BlakeJS
              </a>
            </h3>
          </div>
        </header>
        <v-divider></v-divider>
        <div class="px-3" style="display:flex;flex-direction:column;">

          <p class="py-4 subheading">Driven engineer with over 7 years of proven professional
            experience. Passionate about solving problems and building digital
            products with a focus on scalable front-end systems and user
            experience in the browser. In short, facilitating custom front-end solutions and helping businesses build international, accessible, and efficient sites and apps.</p>

          <h2 class="text-xs-left pb-1">
            <u>Experience</u>
          </h2>

          <div class="exp-top pt-3">
            <h3>Corsair</h3>
            <h3 style="text-align:right">
              <i>Headless Front-end Developer</i>
            </h3>
          </div>
          <div class="exp-top">
            <a href="https://corsair.com/">https://corsair.com/</a>
            <p style="text-align:right">March 2023 - Present</p>
          </div>
          <ul>
            <li>Partnered with the IT & Marketing teams to deliver innovative, high-impact digital experiences, launching new products and advancing the future of gaming through collaborative design and performance optimization.</li>
            <li>Driving growth in the development of a scalable, headless front-end ecosystem, ensuring exceptional speed, reliability, and user engagement across platforms.</li>
            <li>Champion for a culture of continuous improvement, leveraging emerging technologies to set new standards in web performance and interactive design.</li>
          </ul>

          <div class="exp-top pt-3">
            <h3>Scuf Gaming @ Corsair</h3>
            <h3 style="text-align:right">
              <i>Front-end Developer</i>
            </h3>
          </div>
          <div class="exp-top">
            <a href="https://scufgaming.com/">https://scufgaming.com/</a>
            <p style="text-align:right">July 2021 - March 2023</p>
          </div>
          <ul>
            <li>Worked with the web team to develop rich and unique web experiences, push exciting new products, collaborate on design processes, optimize pages & page performance, and explore the future of gaming innovation.</li>
            <li>Scaled a headless front-end ecosystem to deliver a highly performant and user-centric experience.</li>
            <li>Helped launch the Instinct, Valor, Reflex, Envision products (controllers for Xbox, Playstation 5, and PC). The launches were resoundingly successful, driving millions of page views to the site, selling out in record time, and earning high praise from gaming hardware reviewers.</li>
          </ul>

          <div class="exp-top pt-3">
            <h3>Polyglot Labs</h3>
            <h3 style="text-align:right">
              <i>Front-end Developer</i>
            </h3>
          </div>
          <div class="exp-top">
            <a href="https://polyglotlabs.com/">https://polyglotlabs.com/</a>
            <p style="text-align:right">September 2018 — December 2020</p>
          </div>
          <ul>
            <li>Led new website, app and theme development
              projects through the full development cycle with Kanban
              from initial concept through planning, design, review,
              development, QA, launch and maintenance.</li>
            <li>Enhanced a vast array of websites, plugins and applications
              which resulted in increased conversion rates, performance
              and sales for both small and large businesses around the Atlanta area.</li>
            <li>Improved code (strong PHP & Angular Stack), took
              amazing designs and made them real, performed unit
              testing, mentoring, time tracking and documentation.</li>
          </ul>

          <div class="exp-top pt-3">
            <h3>Counters</h3>
            <h3 style="text-align:right">
              <i>Web Developer</i>
            </h3>
          </div>
          <div class="exp-top">
            <div>
              <strong>
                Super Smash Bros Ultimate Counters, Dragon Ball FighterZ Counters,<br> Mobile Legends Counters, Quake Counters, etc.
              </strong>
            </div>
            <p style="text-align:right">January 2018 - September 2018</p>
          </div>
          <ul>
            <li>Created a content template (Handlebars.js &
              Express.js with a custom RESTful API and MongoDB backend) for a
              variety of competitive games with the help of my coding mentor.</li>
            <li>Scaffolded using AWS Infrastructure which
              allowed for fast EC2 auto scaling and efficient load balancing.</li>
            <li>Marketed to hundreds of thousands of viewers and served
              as a helpful pillar in a few online gaming communities.</li>
          </ul>

          <div class="exp-top pt-3">
            <h3>Southern Architectural Stone</h3>
            <h3 style="text-align:right">
              <i>Web Developer</i>
            </h3>
          </div>
          <div class="exp-top">
            <p style="text-align:right">2016 - 2017</p>
          </div>
          <ul>
            <li>Successfully took an amazing website concept and made it
              a reality.</li>
            <li>The website generated new sales for the business
              and was received with stellar remarks.</li>
            <li>Trained staff on how to use and update the custom (WordPress)
              content management back-end.</li>
            <li>No prior website or marketing strategy existed before the
              endeavor to create one.</li>
          </ul>

          <h2 class="text-xs-left pt-4">
            <u>Projects</u>
          </h2>

          <div class="exp-top pt-1">
            <h3>Awesomely</h3>
            <h3 style="text-align:right">
              <i>Passion Project</i>
            </h3>
          </div>
          <div class="exp-top">
            <a href="https://blakejs.github.io/awesomely/">https://blakejs.github.io/awesomely/</a>
            <p style="text-align:right">2018</p>
          </div>
          <ul>
            <li>Dashboard for making Awesome List more organizable and readable.</li>
            <li>This project got me into the GitHub Developer Program and helped other developers in the community.</li>
            <li>Built with: Vue.js, Vuetify, Webpack, JSON (Source code available)</li>
          </ul>

          <div class="exp-top pt-3">
            <h3>Kendama Community</h3>
            <h3 style="text-align:right">
              <i>Founder</i>
            </h3>
          </div>
          <div class="exp-top">
            <a href="https://kendama.co/">https://kendama.co/</a>
            <p style="text-align:right">January 2021 - Present</p>
          </div>
          <ul>
            <li>Focused on providing players with the resources they need to get into Kendama.</li>
            <li>Social media presence on: Tiktok, Youtube, Instagram, Facebook and Twitter.</li>
          </ul>

          <div class="exp-top pt-3">
            <h3>Litterboxd</h3>
            <h3 style="text-align:right">
              <i>Passion Project</i>
            </h3>
          </div>
          <div class="exp-top">
            <p style="text-align:right">2021</p>
          </div>
          <ul>
            <li>Dashboard for finding and watching movies with your cat.</li>
            <li>Built with: React.js, Axios, and TMDB (Source code available)</li>
          </ul>

          <div class="exp-top pt-3">
            <h3>Physics Blog</h3>
            <h3 style="text-align:right">
              <i>Project</i>
            </h3>
          </div>
          <div class="exp-top">
            <div>
              WordPress
            </div>
            <p style="text-align:right">2013 - 2014</p>
          </div>
          <ul>
            <li>One of my first ever websites was created during junior year of high school for Physics!</li>
            <li>Built with: Wordpress (Source code available)</li>
          </ul>

          <h2 class="text-xs-left pb-3">
            <u>Skills</u>
          </h2>

          <h3>Strengths</h3>
          <ul>
            <li>HTML5, CSS3, and Modern JavaScript</li>
            <li>React & Vue, Redux & Vuex, ES6+, Typescript, PHP, SASS, LESS, Web Tools, Git, APIs</li>
            <li>CSS Frameworks: Bootstrap, Bulma, Vuetify, Material-UI.</li>
            <li>Databases: MongoDB, MySQL, PostgreSQL.</li>
            <li>Bundling pipelines: Webpack, Gulp, Browserify, DDEV.</li>
            <li>ENV Tools: Git, Bash, SSH, Docker, Yarn, NPM</li>
            <li>Compilers & Linters: Babel, ESLint, PHPLint.</li>
            <li>Content Management Systems: Shopify, WordPress, Magento, Contentful, Prismic</li>
            <li>Development & Design Tools: Visual Studio Code, Photoshop, Office, Todoist, MURAL.</li>
            <li>Software Development Methodologies: Unit Testing, Software Design Patterns (Gang of 4), Documentation Patterns (Commenting, PR review, etc), Data Structures and Algorithms Efficience, Debugging Techniques, Version Control.</li>
          </ul>
          <br>
          <h3>Personal Qualities</h3>
          <ul>
            Collaborator, Communicator, Problem-solver,
            Studious, Well Organized, Proficient Multitasker,
            Management Skills, Efficient Work, Customer Service,
            Conflict Resolver, Teamwork, Persistence,
            High Energy, Tending to Customer Needs, Thoroughness,
            Professionalism, Fostering Relationships, Physical Stamina,
            Articulate & Well Spoken, Technology Savvy,
            Adaptable to New Trends, Responsible, Creative
          </ul>

          <h3 class="py-5">More information available upon request.</h3>
        </div>
      </v-card>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Resume",
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=EB+Garamond");

.container {
  background: linear-gradient(270deg, #9bf6dc60, #43cdf360);
  display: grid;
  place-items: center;
  padding-top: 50px;
}

.exp-top {
  font-family: "EB Garamond", serif;
  font-size: 1.2em;
  display: grid;
  grid-auto-flow: column;
}

header div {
  text-align: start;
  place-items: start;
  display: flex;
  grid-auto-flow: column;
}

h1,
h2,
h3 {
  font-family: Arial, Helvetica, sans-serif;
}

h1 {
  font-size: 3em !important;
}

a {
  color: mediumblue;
}

.resume-page {
  max-width: 900px;
  min-width: 100%;
}

@media (max-width: 900px) {
  .exp-top {
    grid-auto-flow: row;
    place-content: start;
  }

  .exp-top p,
  h3 {
    text-align: start !important;
  }

  .container {
    padding: 0 !important;
  }

  header {
    flex-direction: column;
    align-items: start;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Resume.vue